import React from 'react';
import axios from "axios";
import { useState } from 'react';
import { Button, Form, FloatingLabel } from 'react-bootstrap';
import { Link } from 'react-router-dom';


  const EInvoicingSoftware = () => {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [number, setNumber] = useState('')
    const [company, setCompany] = useState('')
    const [statusCode, setStatusCode] = useState('')
    const [message, setMessage] = useState('')

const API_PATH = 'http://amosta.com/reactJs/EinVoiceingSoftware.php';
function axios2() {

axios({
  method: 'post',
  url: API_PATH,
  headers: {
    'content-type': 'application/json'

  },
  data: {
    "name": name,
    "email": email,
    "number": number,
    "company": company

  }
})
  .then(result => {
    if (result.data.statusCode === 200) {
      setStatusCode(result.data.statusCode)
      setMessage(result.data.message)
      window.location.reload(false)
    } else {
      setStatusCode(result.data.statusCode)
      setMessage(result.data.message)
    }
    console.log(result);
  })
  .catch(error => {
    console.log(error)
  });
}

  return (
    <div className='bg-white'>
      <img className='img-fluid gst-software-main-banner' src="./assets/images/einvocing-banner-bg.jpg" alt="" />
      <div className="container gst-software-section-2">
        <div className="row">
          <div className="col-sm-12 col-md-6">
            <h2 className=''>Get Started with GSTrobo End-to-End e-Invoicing
              Software for Free*</h2>
            <div className="container mt-5">
              <ul>
                <li><p>Quick Implementation.</p></li>
                <li><p>24x7 Assistance.</p></li>
                <li><p>Great Return on Investment.</p></li>
                <li><p>100% Data Security.</p></li>
              </ul>

            </div>
          </div>
          <div className="col-sm-12 col-md-6">
            <div className="container gst-software-first-form p-5 bg-light text-dark text-center border-0 rounded-2 shadow-lg w-75" style={{ marginTop: '150px' }}>
            <h5>{statusCode}</h5>
                        <h5>{message}</h5>
                            <Form autoComplete="off">
                                <h3 className='mb-3'>Request a Call</h3>
                                <FloatingLabel controlId='fullName' label='Full Name' className='mb-3'>
                                    <Form.Control type='text' placeholder='Full Name' id='name' name="name" onChange={(e) => setName(e.target.value)} required />
                                </FloatingLabel>
                                <FloatingLabel controlId='phone' label='Mobile Number' className='mb-3'>
                                    <Form.Control type='number' placeholder='Phone number' id='number' name="number" onChange={(e) => setNumber(e.target.value)} required />
                                </FloatingLabel>
                                <FloatingLabel controlId='emailId' label='Email Id' className='mb-3'>
                                    <Form.Control type='email' placeholder='name@example.com' id='email' name="email" onChange={(e) => setEmail(e.target.value)} required />
                                </FloatingLabel>
                                <FloatingLabel controlId='companyName' label='Company Name' className='mb-3'>
                                    <Form.Control type='text' placeholder='Company Name' id='company' name="company" onChange={(e) => setCompany(e.target.value)} required />
                                </FloatingLabel>
                                <Button type="button" onClick={axios2} className='text-center mt-3' variant='success'>Submit</Button>
                            </Form>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container gstrobo-section-3 mt-5 text-center pb-5">
          <h1 className='pt-5'>Faster, Better, and Robust Customer Assistance</h1>
          <p className='text-muted'>Ensuring Compliance, Reliability & Efficiency</p>
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-4">
                <div className="card align-items-center mt-3 shadow" style={{ height: '330px' }}>
                  <img className='img-fluid mt-4 gst-card-img' src="assets/images/24x7.png" alt="" />
                  <h4 className='mt-3 text-success p-2'>24x7 Customer Assistance</h4>
                  <p className='p-3' align='justify'>On-call engineers and subject matter experts are available 24 hours a day, 7 days a week to help you with any issue.</p>
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <div className="card align-items-center mt-3 shadow" style={{ height: '330px' }}>
                  <img className='img-fluid mt-4 gst-card-img' src="assets/images/relationship-manager.png" alt="" />
                  <h4 className='mt-3 text-success p-2'>Dedicated Relationship Manager</h4>
                  <p className='p-3' align='justify'>Sit back and relax, let your dedicated relationship manager handle your query, & get it resolved within 2 Hours.</p>
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                <div className="card align-items-center mt-3 shadow" style={{ height: '330px' }}>
                  <img className='img-fluid mt-4 gst-card-img' src="assets/images/sla-support.png" alt="" />
                  <h4 className='mt-3 text-success p-3'>Steadfast SLA Support</h4>
                  <p className='p-3' align='justify'>With one of the best support teams in the industry, we're able to provide an industry-leading 30 minutes (or less) support SLA.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-light">
      <div className="container pt-5">
        <div className="row">
          <div className="col-sm-12 col-md-4 d-flex flex-column justify-content-center">
            <h1><span style={{ color: '#ed7a38' }}>E-Invoicing Software</span> that is Compatible with all<span className='text-success'> ERPs</span></h1>
          </div>
          <div className="col-sm-12 col-md-8">
            <img src="assets/images/gstrobo-einvoicing-erp.png" alt="" className="img-fluid mt-5" />
          </div>
        </div>
      </div>
      </div>

        <div className="container text-center">
          <h1 className="mt-5 pt-5 pb-3">Focus on What Matters Most - <span className='text-success'>Your Business</span></h1>
          <p>What can you do to get ready for e-invoicing? Use ERP connectors to assess the internal system's readiness. Integrate with a high-fidelity solution to address the crucial e-invoicing process. Upgrade to GSTrobo® e-invoicing platform, which has a 99.99% uptime guaranteed.</p>
          <video muted autoPlay loop className='img-fluid mb-5' src="./assets/videos/e-invoicing-process.mp4"></video>
        </div>

      <div className="bg-light">
        <div className="container pb-5">
          <div className="row">
            <div className="col-sm-12 col-md-6 mt-5 order-md-2 d-flex flex-column justify-content-center">
              <h1>E-Invoicing Software Integration as Per your Convenience</h1>
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <ul>
                    <li><p>API-Based</p></li>
                    <li><p>FTP-Based</p></li>
                    <li><p>Desktop-Based Application</p></li>
                  </ul>

                </div>
                <div className="col-sm-12 col-md-6">
                  <ul>
                    <li><p>Excel Mapping</p></li>
                    <li><p>Web-Based</p></li>
                  </ul>

                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 order-md-1">
              <img src="assets/images/e-Invoicing-software-integration.png" alt="" className="img-fluid mt-5" />
            </div>
          </div>
        </div>
      </div>

      <div className="container">
      <div className="container text-center">
          <h1 className="mt-5 pt-5 pb-3"><span className="text-success">GSTrobo E-Invoicing Software</span> - A One-Stop Solution for all your E-Invoicing Needs</h1>
          <img src="assets/images/gstrobo-one-stop-solution.png" alt="" className="img-fluid" />
        </div>
        </div>


      <div className="bg-light">
        <div className="container gstrobo-section-3 mt-5 text-center pb-5">
          <h1 className='pt-5'><span style={{ color: '#f43f47' }}>GST</span> Products</h1>
          <p className='text-muted'>Ensuring Compliance, Reliability & Efficiency</p>
          <div className="gstrobo-cards">
            <div className="card gst-card shadow">
              <img className='img-fluid gst-card-img' src="assets/images/invoice.png" alt="" />
              <h4 className='mt-3'>GST Software</h4>
              <Link to='/gst-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
            </div>
            <div className="card gst-card shadow">
              <img className='img-fluid gst-card-img' src="assets/images/real-time-goods.png" alt="" />
              <h4 className='mt-3'>E-Way Bill Software</h4>
              <Link to='/e-way-bill-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
            </div>
            <div className="card gst-card shadow">
              <img className='img-fluid gst-card-img' src="assets/images/one-click-icon.png" alt="" />
              <h4 className='mt-3'>E-Invoicing Software</h4>
              <Link to='/e-invoicing-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
            </div>
            <div className="card gst-card shadow">
              <img className='img-fluid gst-card-img' src="assets/images/api.png" alt="" />
              <h4 className='mt-3'>GST & E-Way Bill API</h4>
              <Link to='/gst-e-way-bill-api'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
            </div>
            <div className="card gst-card shadow">
              <img className='img-fluid gst-card-img' src="assets/images/reconcile.png" alt="" />
              <h4 className='mt-3'>Intelligence Insight</h4>
              <Link to='/intelligence-insight'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
            </div>
            <div className="card gst-card shadow">
              <img className='img-fluid gst-card-img' src="assets/images/ledger.png" alt="" />
              <h4 className='mt-3'>Value Added Tools</h4>
              <Link to='/value-added-tools'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}
export default EInvoicingSoftware;